import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ordenar'
})

export class OrdenarPipe implements PipeTransform {
  transform(arreglo: any[], campo: string, ascendente = true): any[] {
    if (arreglo ? !arreglo.length: false) return[]; 
    if (!campo) return arreglo;  
    return arreglo.sort((a: any, b: any) => {
      const uno = a[campo] ? String(a[campo]).toLowerCase() : '';
      const dos = b[campo] ? String(b[campo]).toLowerCase() : '';
      if (uno < dos) return ascendente ? -1 : 1;
      if (uno > dos) return ascendente ? 1 : -1;
      return 0;
    });
  }
}